<template>
	<div class="jiedaiOrder">
		<div class="radioBox">
			<el-radio-group v-model="radio" @change="changeRadio">
				<el-radio :label="0">全部</el-radio>
				<!-- <el-radio :label="6">待结算</el-radio> -->
				<el-radio :label="1">寄养中</el-radio>
				<el-radio :label="2">已完成</el-radio>
				<!-- <el-radio :label="9">已取消</el-radio> -->
			</el-radio-group>
		</div>
		<el-table :data="tableData" height="100%" style="width: 100%;">
			<el-table-column label="状态" width="80">
				<template slot-scope="scope">
					{{scope.row.careStatus===1?'寄养中':'已结束'}}
				</template>
			</el-table-column>
			<!-- <el-table-column label="服务" width="160">
				<template slot-scope="scope">
					{{scope.row.serviceName}}
				</template>
			</el-table-column> -->
			<el-table-column label="顾客">
				<template slot-scope="scope">
					{{scope.row.memberName}}
				</template>
			</el-table-column>
			<el-table-column label="宠物">
				<template slot-scope="scope">
					{{scope.row.petNames.join(' ')}}
				</template>
			</el-table-column>
			<el-table-column label="支付方式" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.depositType===1">押金</span>
					<span v-if="scope.row.depositType===2">余额</span>
				</template>
			</el-table-column>
			<el-table-column label="自动扣费" width="80">
				<template slot-scope="scope">
					{{scope.row.autoDeduct?'是':'否'}}
				</template>
			</el-table-column>
			<!-- <el-table-column label="单价" width="70">
				<template slot-scope="scope">
					{{scope.row.servicePrice}}
				</template>
			</el-table-column> -->
			<el-table-column label="创建时间" width="150">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.createTime,'YYYY-MM-DD HH:mm')}}
				</template>
			</el-table-column>
			<el-table-column label="销售人员" width="120">
				<template slot-scope="scope">
					<span v-for="item in scope.row.serviceMan" :key="item">{{item+' '}}</span>
				</template>
			</el-table-column>
			<el-table-column label="单号" width="100">
				<template slot-scope="scope">
					<span >{{scope.row.careId}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="130">
				<template slot-scope="scope">
					<el-button type="text" @click="see(scope.row)">查看</el-button>
					<!-- <el-button v-if="scope.row.status===1" type="text" @click="editPet(scope.row)">编辑</el-button> -->
					<!-- <el-button v-if="scope.row.careStatus===1" type="text" @click="stopPet(scope.row)">结束</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<jiyangPetSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></jiyangPetSee>
		<jiyangPetEdit v-if="drawerJiyangPetEdit_state" :curItem="curItem" @close="submit_drawerJiyangPetEdit"></jiyangPetEdit>
		<jiyangSee v-if="drawerJiyangSee_state" :curItem="curItem" @close="submit_drawerJiyangSee"></jiyangSee>
	</div>
</template>
<script>
	import page from "../../../../../components/page.vue"
	import dialogSettlement from "../../../../../components/dialog_settlement.vue"
	import jiyangPetSee from "../../drawer/jiyangPetSee.vue"
	import jiyangPetEdit from "../../drawer/jiyangPetEdit.vue"
	import jiyangSee from "../../drawer/jiyangSee.vue"
	export default {
		components:{page,dialogSettlement,jiyangPetSee,jiyangPetEdit,jiyangSee},
		data(){
			return{
				radio:0,
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// seePet
				drawerJiyangPetSee_state:false,
				// see
				drawerJiyangSee_state:false,
				// editPet
				drawerJiyangPetEdit_state:false,
				curItem:{},
				// 结算
				dialogSettlementState: false,
				curOrder: {},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// changeRadio
			changeRadio(){
				this.page.page=1;
				this.getTableData();
			},
			// 结算
			pay(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData();
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			see(row){
				this.drawerJiyangSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangSee(){
				this.drawerJiyangSee_state = false;
			},
			editPet(row){
				this.drawerJiyangPetEdit_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetEdit(){
				this.drawerJiyangPetEdit_state = false;
				this.getTableData();
			},
			stopPet(row){
				this.see(row)
			},
			changePage(num){
				this.page.page=num;
				this.getTableData();
			},
			// 获取列表数据
			getTableData() {
				// let curDay = this.$public.FTime(new Date().getTime(),'YYYY-MM-DD')
				let params = {
					// startDate: ('' + (new Date(curDay).getTime()-28800000)).substr(0, 10),  //开始时间
					// endDate: ('' + (new Date(curDay).getTime()+86400000-28800000)).substr(0, 10),	//结束时间
					startDate: '',  //开始时间
					endDate: '',	//结束时间
					"status": this.radio,
					"depositType": 0,
					"autoDeduct":-1,
					petId:'',
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ""
				}
				let loading = this.$loading()
				this.$http.post('/api/FosterCare/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.jiedaiOrder{
	width:100%;height: 100%;padding-bottom:50px;box-sizing: border-box;padding-top:40px;position: relative;
	.radioBox{
		padding:12px 30px 12px;position: absolute;z-index: 1;top:0;width:100%;box-sizing: border-box;
	}
	.pageBox{
		// padding:20px;
	}
}
</style>
